import { connect } from 'react-redux';
import PortalPage from '../components/PortalPage';
import { logout } from '../../auth/actions';
import * as actions from '../actions';

const mapStateToProps = state => ({
  isAdmin: state.auth.isAdmin,
  isAuthenticated: state.auth.isAuthenticated,
  isProfilingTagsManager: state.auth.isProfilingTagsManager,
  clientEmail: state.auth.clientEmail
});

const mapDispatchToProps = dispatch => ({
  onLogout: () => dispatch(logout()),
  onSearchCampaigns: search => dispatch(actions.searchCampaigns(search))
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PortalPage);
